module.exports = __webpack_public_path__ + "img/Identity-Pattern1.0a0e1f5c.svg";